import React, { ReactNode } from 'react';
import { createClient, fetchExchange, Provider } from 'urql';

import { urlForGraphQL } from 'utils/api/lib/url';
import { fetchWithHeaders } from 'utils/graphql/client/fetchWithHeaders';
import { warnOnComplexQueriesExchange } from 'utils/graphql/client/warnOnComplexQueriesExchange';
import { passThroughErrorStatus } from 'utils/graphql/client/passThroughErrorStatus';

const complexityLimit = 7500;

type Props = { children: ReactNode };

export const GraphQLClientProvider = ({ children }: Props) => {
  const client = createClient({
    preferGetMethod: false,
    url: urlForGraphQL(),
    fetch: fetchWithHeaders,
    exchanges: [
      warnOnComplexQueriesExchange({
        complexityLimit,
      }),
      passThroughErrorStatus(),
      fetchExchange,
    ],
  });
  return <Provider value={client}>{children}</Provider>;
};

export const internals = {
  fetchWithHeaders,
};
